import { Button } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { updateProperties } from "../../../api/properties/updateProperties";
import TokenContext from "../../../context/Token";

const SendToProceedings = (props) => {
  const { token } = useContext(TokenContext);
  const navigate = useNavigate();

  const sendData = async () => {
    try {
      const response = await updateProperties(token, props.id, {
        status: "Expediente",
        legal: false
      });

      if (response._id) {
        navigate(0);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Button onClick={() => sendData(true)} sx={{ my: 0 }}>
      Enviar a Integración de Expediente
    </Button>
  );
};

export default SendToProceedings;
